import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../../styles/forfeo-2026.css";

type Family = "public"|"auth"|"discovery"|"traveler"|"onboarding"|"merchant"|"prp"|"admin"|"transaction"|"wallet"|"special"|"utility";

const familyForPath = (pathname: string): Family => {
  const path = pathname.toLowerCase();
  if (path === "/login") return "auth";
  if (path.startsWith("/prp-dashboard")) return "prp";
  if (path.startsWith("/admin")) return "admin";
  if (path.startsWith("/business-dashboard") || path === "/business") return "merchant";
  if (path.startsWith("/register-business")) return "onboarding";
  if (path.startsWith("/dashboard-voyageur") || path.startsWith("/club") || path.startsWith("/mes-reservations") || path.startsWith("/mes-achats") || path.startsWith("/mes-favoris") || path.startsWith("/mes-alertes") || path.startsWith("/mon-compte") || path.startsWith("/gestion-compte")) return "traveler";
  if (path.startsWith("/explorer-plus") || path.startsWith("/explore/") || path.startsWith("/region/") || path.startsWith("/place/") || path.startsWith("/visiter-quebec") || path.startsWith("/decouvrir-quebec") || path === "/carte") return "discovery";
  if (path.startsWith("/checkout") || path.startsWith("/booking/") || path.startsWith("/reservation/") || path.startsWith("/voucher/")) return "transaction";
  if (path.startsWith("/carte-cadeau") || path.startsWith("/gift-card")) return "wallet";
  if (path.startsWith("/habitat") || path.startsWith("/reserve") || path.startsWith("/affiliate-dashboard") || path.startsWith("/forfeopro")) return "special";
  if (path === "/" || path.startsWith("/about") || path.startsWith("/comment-ca-marche") || path.startsWith("/partenaires") || path.startsWith("/reseau-local") || path.startsWith("/offrir") || path.startsWith("/last-call") || path.startsWith("/boutique")) return "public";
  return "utility";
};

export default function Forfeo2026RouteSkin() {
  const location = useLocation();
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const family = familyForPath(location.pathname);
    html.dataset.forfeoDesign = "2026";
    html.dataset.forfeoApp = "explore";
    body.dataset.forfeoDesign = "2026";
    body.dataset.forfeoApp = "explore";
    body.dataset.forfeoFamily = family;
    body.dataset.forfeoRoute = location.pathname;
    return () => { delete body.dataset.forfeoRoute; };
  }, [location.pathname]);
  return null;
}
